import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import { shared } from "../styles.js";
import { parseCoord } from "../lib/format.js";

/**
 * deps-panel renders the dependency closure the CLI would pull (R9): each entry is
 * a "@scope/name@ref" string that links to its package page.
 */
@customElement("deps-panel")
export class DepsPanel extends LitElement {
  static override styles = [
    shared,
    css`
      .dep {
        display: block;
        padding: 4px 0;
        font-family: var(--mono);
        font-size: 13px;
      }
      .ref {
        color: var(--muted);
      }
    `,
  ];

  @property({ attribute: false }) deps: string[] = [];

  override render() {
    if (!this.deps.length) {
      return html`<p class="muted">No dependencies.</p>`;
    }
    return html`${this.deps.map((d) => {
      const at = d.lastIndexOf("@");
      // a leading '@' is the scope sigil; the dependency ref '@' is the last one
      const hasRef = at > 0;
      const coord = hasRef ? d.slice(0, at) : d;
      const ref = hasRef ? d.slice(at + 1) : "";
      const { scope, name } = parseCoord(coord);
      return html`<a class="dep" href=${`/p/${scope}/${name}`}
        >${coord}${ref ? html`<span class="ref">@${ref}</span>` : ""}</a
      >`;
    })}`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "deps-panel": DepsPanel;
  }
}
